/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listShiftTemplates} from '../api'

export const useMutationListShiftTemplates = createReactQueryMutationHook('listShiftTemplates', listShiftTemplates)
